import { useEffect } from 'react';
import { useFormik } from 'formik';
import { FunctionarySwitch } from '../../../../../../shared/types/modules/switch';

export const useFunctionarySwitchDetail = (
    functionarySwitchDetail?: FunctionarySwitch
) => {
    const formik = useFormik({
        initialValues: {
            area: '',
            functionary: '',
            emailFunctionary: '',
            extFunctionary: '',
            functionaryAttendedCall: '',
            templateEmail: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        if (!functionarySwitchDetail) return;

        const {
            area: areaRaw = '',
            functionary: funcRaw = '',
            emailFunctionary = '',
            extFunctionary = '',
            functionaryAttendedCall = '',
            templateEmail = '',
        } = functionarySwitchDetail;

        const area =
            areaRaw && typeof areaRaw === 'object' && 'name' in areaRaw
                ? (areaRaw as any).name
                : (areaRaw as string) || '';

        const functionary =
            funcRaw && typeof funcRaw === 'object' && 'name' in funcRaw
                ? `${(funcRaw as any).name} ${(funcRaw as any).surname || ''}${
                    (funcRaw as any).position?.name
                        ? ` - ${(funcRaw as any).position.name}`
                        : ''
                }`.trim()
                : (funcRaw as string) || '';

        formik.setValues({
            area,
            functionary,
            emailFunctionary,
            extFunctionary,
            functionaryAttendedCall,
            templateEmail,
        });
    }, [functionarySwitchDetail]);

    return { formik };
};
